import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { LanguageProvider } from './context/languageContext';
import { ActiveModesProvider } from './context/ActiveModesContext';
import { RoleProvider } from './context/roleContext';
import i18n from './translations/i18n'; // Adjust the path if necessary

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <ActiveModesProvider>
        <RoleProvider>
          <HashRouter>
            <App />
          </HashRouter>
        </RoleProvider>
      </ActiveModesProvider>
    </LanguageProvider>
  </React.StrictMode>
);
